import { WhiteLabelLandingPage } from "@/features/white-label-landing-page";
import { useIsWhiteLabelDomain } from "@/hooks/isWhiteLabelDomain";
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate, NavigateOptions, useRouter } from "@tanstack/react-router";
import { ComponentType, FC } from "react";

export const withAuthentication = <P extends object>(
  Component: ComponentType<P>
): FC<P> => {
  return function WithAuthentication(props: P): JSX.Element {
    const { state } = useRouter();
    const { location } = state;

    const { isAuthenticated } = useAuth0();

    const { isWhiteLabelDomain } = useIsWhiteLabelDomain();

    if (!isAuthenticated && isWhiteLabelDomain) {
      return <WhiteLabelLandingPage redirect={location.href} />;
    }

    if (!isAuthenticated) {
      const navigateTo: NavigateOptions["to"] =
        location.search && "signup" in location.search && location.search.signup
          ? "/signup"
          : "/login";
      return <Navigate to={navigateTo} search={{ redirect: location.href }} />;
    }

    return <Component {...props} />;
  };
};
